import { dependentKeyCompat } from '@ember/object/compat';
import { A as emberA } from '@ember/array';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { equal, gt, reads } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
import BillingItemMixin from 'client-portal/mixins/polymorphic/billing-item';
import Model, { attr, hasMany } from '@ember-data/model';

export default class InvoiceModel extends Model.extend(BillingItemMixin) {
  @hasMany('invoice-item', { async: false, inverse: 'invoice' }) invoiceItems;

  @attr() displayName;
  @attr() displayStatus;
  @attr('moment') invoiceDate;
  @attr() totalAmount;
  @attr() remainingAmount;
  @attr('boolean') isChannelBilled;
  @attr() isNewForClient;
  @reads('invoiceDate') activityDate;
  @reads('totalAmount') activityCharges;
  @equal('displayStatus', 'paid') isPaid;
  @equal('displayStatus', 'past due') isPastDue;
  @gt('allocatedAmount', 0) hasPayments;

  get badgeClass() {
    if (this.isPaid) {
      return 'mint';
    } else if (this.displayStatus) {
      return 'wine';
    }

    return null;
  }

  get isHiddenChannelBilled() {
    return this.isChannelBilled && !this.isPaid;
  }

  get isUnread() {
    return !this.isPaid && !this.opened && this.isNewForClient;
  }

  // @dependentKeyCompat so the classic `@gt('allocatedAmount', 0) hasPayments`
  // macro re-fires when the underlying @attr amounts change.
  @dependentKeyCompat
  get allocatedAmount() {
    return this.totalAmount - this.remainingAmount;
  }

  get numberOfAppointments() {
    return this.invoiceItems.map(invoiceItem => invoiceItem.appointment).uniqBy('startTime').length;
  }

  // Tracked so `isUnread` recomputes when `billing-modals` marks the invoice
  // as opened (via `model.set('opened', true)`); matches receipt.js.
  @tracked opened = false;
  activityPayments = null;

  static fieldsFor(_context) {
    let fields = emberA();
    this.fields.forEach((_, v) => fields.pushObject(v));
    fields.removeObject('meta');
    return fields;
  }
}
